import { EncounterActionSelectionQueryMap } from '../components/actions/encounterActionSelection'
import { EncounterDetailTabQueryMap } from '../components/EncounterTabs'
import { EncounterAgentSessionQueryMap } from '../hooks/useAgentSessionTabs'
import { EncounterSidebarQueryMap } from '../hooks/useEncounterSidebarTabs'
import { WorkBlockHistoryQueryMap } from '../../work-blocks/utils/workBlockHistoryQuery'
import type { inferParserType } from 'nuqs'
import {
  createSerializer,
  parseAsBoolean,
  parseAsString,
  useQueryStates,
} from 'nuqs'
import { parseAsUuid } from '@joyful/utils'

export const EncounterBrowserSpecialistViewQueryMap = {
  browser_task_id: parseAsUuid,
}

export const EncounterSubagentViewQueryMap = {
  subagent_conversation_id: parseAsUuid,
}

export const EncounterRouteQueryParamMap = {
  ...EncounterActionSelectionQueryMap,
  ...EncounterSidebarQueryMap,
  ...EncounterAgentSessionQueryMap,
  ...EncounterDetailTabQueryMap,
  ...EncounterBrowserSpecialistViewQueryMap,
  ...EncounterSubagentViewQueryMap,
  ...WorkBlockHistoryQueryMap,
  attachment: parseAsString,
  packet_id: parseAsUuid,
  prevent_redirect: parseAsBoolean.withDefault(false),
  redirected_from: parseAsUuid,
}

export type EncounterRouteQueryParams = inferParserType<
  typeof EncounterRouteQueryParamMap
>

export const serializeEncounterRouteQueryParams = createSerializer(
  EncounterRouteQueryParamMap,
)

export function useEncounterBrowserSpecialistViewQueryParams() {
  return useQueryStates(EncounterBrowserSpecialistViewQueryMap, {
    history: 'push',
  })
}

export function useEncounterSubagentViewQueryParams() {
  return useQueryStates(EncounterSubagentViewQueryMap, {
    history: 'push',
  })
}
